import React, { useState, useEffect } from 'react';


import { TextField, Button, Container, Typography, TextareaAutosize } from '@mui/material'; // já deve estar no topo

import axios from 'axios';

export default function DuvidasSugestoes() {
  const [mensagem, setMensagem] = useState('');
const [usuario, setUsuario] = useState(() => {
  try {
    const raw = localStorage.getItem('usuarioAtual');
    const user = JSON.parse(raw);
    return user?.login || '';
  } catch {
    return '';
  }
});


  const [enviado, setEnviado] = useState(false);
  const [sugestoes, setSugestoes] = useState([]);
  const [sugestaoSelecionada, setSugestaoSelecionada] = useState(null);

  
const [mensagemEdicao, setMensagemEdicao] = useState('');
const [imagens, setImagens] = useState([]);

const [filtro, setFiltro] = useState('');
const [exibirPendentes, setExibirPendentes] = useState(true); // Exibir pendentes por padrão
const [exibirConcluidos, setExibirConcluidos] = useState(false); // Ocultar concluídos por padrão





  const enviarSugestao = async () => {

    if (!mensagem.trim()) return;
    try {
      await axios.post('/api/anp/sugestao', {
        usuario,
        mensagem
      });
      setEnviado(true);
    setMensagem('');
    setTimeout(() => setEnviado(false), 3000); // Oculta a mensagem depois de 3s




    } catch (e) {
      alert('Erro ao enviar sugestão.');
    }
  };


  const handleEficacia = async (foiEficaz) => {
  if (!sugestaoSelecionada) return;

  const novaMensagem = foiEficaz
    ? sugestaoSelecionada.mensagem
    : `${sugestaoSelecionada.mensagem}\n\n[Complemento após feedback de NÃO EFICAZ]:\n${mensagemEdicao}`;

  try {
    await axios.put(`/api/anp/sugestao/${sugestaoSelecionada.id}`, {
      status: foiEficaz ? 'CONCLUIDO' : 'PENDENTE',
      observacao: foiEficaz
        ? 'Usuário confirmou que foi eficaz.'
        : 'Usuário informou que NÃO foi eficaz e complementou.',
      atualizado_por: usuario,
      mensagem: novaMensagem,
      eficacia_resposta: foiEficaz
        ? 'SIM ✅ Obrigado por colaborar com nosso App 😊'
        : 'NÃO ❌ Pedido complementado pelo usuário.'
    });

    const res = await axios.get('/api/anp/sugestoes', {
      headers: { 'x-usuario': usuario }
    });

    setSugestoes(res.data);


const sugestaoAtualizada = res.data.find(s => s.id === sugestaoSelecionada.id);
setSugestaoSelecionada(sugestaoAtualizada || null);
setImagens([]);


    setMensagemEdicao('');
  } catch (e) {
    alert('Erro ao atualizar sugestão.');
  }
};



useEffect(() => {
  const interval = setInterval(() => {
    if (usuario.trim()) {
axios.get('/api/anp/sugestoes', {
  headers: {
    'x-usuario': usuario
  }
})
.then(res => setSugestoes(res.data))
.catch(() => setSugestoes([]));

    }
  }, 3000); // Atualiza a cada 3 segundos

  return () => clearInterval(interval);
}, [usuario]);



const handleUploadImagens = async () => {
  if (!sugestaoSelecionada || imagens.length === 0) return;

  const formData = new FormData();
  imagens.forEach((file) => {
    formData.append('imagens', file);
  });

  try {
    await axios.post(`/api/anp/sugestao/${sugestaoSelecionada.id}/upload-imagens`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });


// ✅ Força recarregar o detalhe da sugestão para pegar as novas imagens
try {
  const detalhe = await axios.get(`/api/anp/sugestao/${sugestaoSelecionada.id}`);
  setSugestaoSelecionada(detalhe.data);
} catch (e) {
  console.error('Erro ao buscar detalhes atualizados após upload de imagem:', e);
}


    alert('Imagens enviadas com sucesso!');
    setImagens([]);

    // ✅ Recarrega a lista de sugestões para garantir que o modal pegue as imagens novas
    const res = await axios.get('/api/anp/sugestoes', {
      headers: { 'x-usuario': usuario }
    });

    setSugestoes(res.data);

// ✅ Sempre buscar do backend o detalhe da sugestão atualizada para garantir imagens novas
try {
  const detalhe = await axios.get(`/api/anp/sugestao/${sugestaoSelecionada.id}`);
  setSugestaoSelecionada(detalhe.data);
} catch (e) {
  console.error('Erro ao buscar detalhes atualizados da sugestão:', e);
}


  } catch (e) {
    console.error('Erro ao enviar imagens:', e);

      if (e.response && e.response.status === 400 && e.response.data?.erro) {
    alert('Esta sugestão já possui 3 imagens. Exclua alguma antes de adicionar novas.');
  } else {
    alert('Erro ao enviar imagens.');
  }


    alert('Erro ao enviar imagens.');
  }
};




  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        Dúvidas ou Sugestões
      </Typography>
<TextField
  label="Seu nome ou login"
  fullWidth
  value={usuario}
  InputProps={{ readOnly: true }}
  sx={{ mb: 2 }}
/>

<Typography sx={{ mb: 1 }}>Digite sua sugestão ou dúvida</Typography>
<TextareaAutosize
  minRows={4}
  placeholder="Escreva aqui..."
  value={mensagem}
  onChange={e => setMensagem(e.target.value)}
  style={{
    width: '100%',
    padding: '12px',
    fontSize: '1rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    resize: 'none',
    marginBottom: '16px'
  }}
/>
      <Button variant="contained" onClick={enviarSugestao}>


        Enviar
      </Button>


        {/* Histórico atualizado automaticamente */}
<Typography sx={{ mt: 1, fontSize: '0.85rem', color: '#888' }}>
  O histórico abaixo é atualizado automaticamente.
</Typography>


{enviado && (
  <Typography sx={{ mt: 2, color: 'green' }}>
    Mensagem enviada com sucesso!
  </Typography>
)}



{usuario && sugestoes.length > 0 && (
  <div style={{ marginTop: '2rem' }}>
    <Typography variant="h6" gutterBottom>Suas sugestões</Typography>

    <TextField
      label="Filtrar sugestões"
      fullWidth
      value={filtro}
      onChange={(e) => setFiltro(e.target.value)}
      sx={{ mb: 2 }}
    />

    {/* Pendentes */}
    <div style={{ marginBottom: '1rem' }}>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setExibirPendentes((prev) => !prev)}
      >
        {exibirPendentes ? '🔽 Ocultar Pendentes' : '▶️ Exibir Pendentes'}
      </Button>

      {exibirPendentes && sugestoes
        .filter((s) =>
          (!filtro || s.mensagem.toLowerCase().includes(filtro.toLowerCase())) &&
          (!s.status || s.status === 'PENDENTE')
        )
        .map((s, i) => (
          <div
            key={s.id}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0.75rem',
              border: '1px solid #ccc',
              borderRadius: 6,
              marginBottom: '0.5rem',
              backgroundColor: '#fffbe6'
            }}
          >
            <div>
              <div><strong>Data:</strong> {new Date(s.data_envio).toLocaleString()}</div>
              <div><strong>Status:</strong> {s.status || 'PENDENTE'}</div>
            </div>
<Button
  variant="outlined"
  size="small"
  onClick={async () => {
    try {
      const detalhe = await axios.get(`/api/anp/sugestao/${s.id}`);
      setSugestaoSelecionada(detalhe.data);
    } catch (e) {
      console.error('Erro ao buscar detalhes da sugestão:', e);
      setSugestaoSelecionada(s);  // Fallback: abre com os dados básicos
    }
  }}
>
  Visualizar
</Button>

          </div>
        ))}
    </div>

    {/* Concluídos */}
    <div style={{ marginBottom: '1rem' }}>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setExibirConcluidos((prev) => !prev)}
      >
        {exibirConcluidos ? '🔽 Ocultar Concluídos' : '▶️ Exibir Concluídos'}
      </Button>

      {exibirConcluidos && sugestoes
        .filter((s) =>
          (!filtro || s.mensagem.toLowerCase().includes(filtro.toLowerCase())) &&
          s.status === 'CONCLUIDO'
        )
        .map((s, i) => (
          <div
            key={s.id}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0.75rem',
              border: '1px solid #ccc',
              borderRadius: 6,
              marginBottom: '0.5rem',
              backgroundColor: '#e0f7e9'
            }}
          >
            <div>
              <div><strong>Data:</strong> {new Date(s.data_envio).toLocaleString()}</div>
              <div><strong>Status:</strong> {s.status}</div>
            </div>
<Button
  variant="outlined"
  size="small"
  onClick={async () => {
    try {
      const detalhe = await axios.get(`/api/anp/sugestao/${s.id}`);
      setSugestaoSelecionada(detalhe.data);
    } catch (e) {
      console.error('Erro ao buscar detalhes da sugestão:', e);
      setSugestaoSelecionada(s);  // Fallback: abre com os dados básicos
    }
  }}
>
  Visualizar
</Button>

          </div>
        ))}
    </div>

    {/* Modal de detalhes */}
    {sugestaoSelecionada && (
      <div
        style={{
          position: 'fixed',
          top: '10%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#fff',
          padding: '2rem',
          borderRadius: 8,
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          zIndex: 9999,
          maxWidth: '500px'
        }}
      >
        <Typography variant="h6" gutterBottom>Detalhes da Sugestão</Typography>
        <div><strong>Usuário:</strong> {sugestaoSelecionada.usuario}</div>
        <div><strong>Mensagem:</strong></div>
        <TextareaAutosize
          value={mensagemEdicao || sugestaoSelecionada.mensagem}
          onChange={(e) => setMensagemEdicao(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            marginTop: '4px',
            fontSize: '0.95rem'
          }}
        />

        <Typography sx={{ mt: 2 }}>A alteração atendeu sua necessidade?</Typography>



        {sugestaoSelecionada.eficacia_resposta && (
          <div
            style={{
              backgroundColor: '#e0f7fa',
              padding: '10px',
              borderRadius: '6px',
              marginTop: '10px',
              color: '#00695c',
              fontWeight: 'bold',
              whiteSpace: 'pre-wrap'
            }}
          >
            {sugestaoSelecionada.eficacia_resposta}
          </div>
        )}


{/* Lista de imagens anexadas */}
{sugestaoSelecionada.imagens && Array.isArray(sugestaoSelecionada.imagens) && sugestaoSelecionada.imagens.length > 0 && (
  <div style={{ marginTop: '1rem' }}>
    <Typography variant="subtitle1">Imagens anexadas:</Typography>
    {sugestaoSelecionada.imagens.map((imgUrl, index) => (
      <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <img
          src={imgUrl}
          alt={`Imagem ${index + 1}`}
          style={{ maxWidth: '80px', maxHeight: '80px', marginRight: '10px', border: '1px solid #ccc' }}
        />
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={async () => {
            if (window.confirm('Tem certeza que deseja excluir esta imagem?')) {
              try {



                console.log('🗑️ [FRONT] Excluindo imagem:', imgUrl, 'da sugestão ID:', sugestaoSelecionada.id);

await axios.delete(`/api/anp/sugestao/${sugestaoSelecionada.id}/imagem`, {
  data: { imagem: imgUrl }
});

console.log('✅ [FRONT] Imagem excluída. Recarregando detalhes da sugestão...');
try {
  const detalhe = await axios.get(`/api/anp/sugestao/${sugestaoSelecionada.id}`);
  console.log('🆕 [FRONT] Sugestão atualizada após exclusão:', detalhe.data);
  setSugestaoSelecionada(detalhe.data);
} catch (err) {
  console.error('❌ Erro ao buscar detalhe atualizado após exclusão:', err);
  alert('Erro ao buscar detalhes atualizados da sugestão.');
}

              } catch (err) {
                alert('Erro ao excluir imagem.');
              }
            }
          }}
        >
          Excluir
        </Button>
      </div>
    ))}
  </div>
)}



{/* Upload de até 3 imagens */}
<input
  type="file"
  multiple
  accept="image/*"
  onChange={(e) => setImagens(Array.from(e.target.files).slice(0, 3))}
/>
<Button
  variant="outlined"
  size="small"
  sx={{ mt: 1, mb: 2 }}
  disabled={imagens.length === 0}
  onClick={handleUploadImagens}
>
  Salvar Imagens ({imagens.length}/3)
</Button>



        <div style={{ marginTop: '0.5rem' }}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => handleEficacia(true)}
            sx={{ mr: 1 }}
          >
            Sim
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleEficacia(false)}
          >
            Não
          </Button>
        </div>

        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 2 }}
          onClick={() => setSugestaoSelecionada(null)}
        >
          Fechar
        </Button>
      </div>
    )}
  </div>
)}





      
    </Container>
  );
}
